import React from 'react';
import { AttributeEditor, Input, Select } from '@amzn/awsui-components-console';
import { MappingEntry } from './configureAttributeStep.types';

interface MappingEditorProps {
	label: string;
	items: MappingEntry[];
	onUpdate: (items: MappingEntry[]) => void;
	info: string;
	keyOptions?: string[];
}

export default function MappingEditor({ label, items, onUpdate, info, keyOptions }: MappingEditorProps) {
	const keySelectOptions = keyOptions?.map((k) => ({ label: k, value: k }));

	return (
		<AttributeEditor
			onAddButtonClick={() => onUpdate([...items, { key: '', value: '' }])}
			onRemoveButtonClick={({ detail: { itemIndex } }) =>
				onUpdate(items.filter((_, i) => i !== itemIndex))
			}
			items={items}
			addButtonText={`Add ${label}`}
			removeButtonText="Remove"
			definition={[
				{
					label: 'Key',
					control: (item: MappingEntry, itemIndex: number) =>
						keySelectOptions ? (
							<Select
								selectedOption={
									keySelectOptions.find((o) => o.value === item.key) || null
								}
								options={keySelectOptions}
								placeholder="Select key"
								filteringType="auto"
								onChange={({ detail }) => {
									const updated = [...items];

									updated[itemIndex] = { ...updated[itemIndex], key: detail.selectedOption.value! };
									onUpdate(updated);
								}}
							/>
						) : (
							<Input
								value={item.key}
								placeholder="Key"
								onChange={({ detail }) => {
									const updated = [...items];

									updated[itemIndex] = { ...updated[itemIndex], key: detail.value };
									onUpdate(updated);
								}}
							/>
						),
				},
				{
					label: 'Value',
					control: (item: MappingEntry, itemIndex: number) => (
						<Input
							value={item.value}
							placeholder={keyOptions ? '#Value#' : 'Value'}
							onChange={({ detail }) => {
								const updated = [...items];

								updated[itemIndex] = { ...updated[itemIndex], value: detail.value };
								onUpdate(updated);
							}}
						/>
					),
				},
			]}
			empty={`No ${label.toLowerCase()} defined.`}
			additionalInfo={info}
		/>
	);
}
